import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import MultipleOfferCheckoutButton from '../_core/checkout/MultipleOfferCheckoutButton';
import Raven from 'raven-js';
import { MARKETING_STARTER } from 'self-service-api/constants/UpgradeProducts';
import { getSource } from 'ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource';
import { mapPurchaseMotionApiName } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  CHECKOUT
} = sourceKeys;
const UICheckoutButton = props => {
  const {
    offerProductConfigurations,
    nonRecurringProductConfigurations,
    productConfigurations,
    upgradeData,
    canViewNewSeats
  } = props;
  if (!offerProductConfigurations || !nonRecurringProductConfigurations || productConfigurations) {
    const migrationIssueLink = 'https://git.hubteam.com/HubSpot/growth-ebx-planning/issues/539#issuecomment-4926440';
    throw new Error(`productConfigurations and offerId are deprecated. Please follow the steps on ${migrationIssueLink} to migrate your UICheckoutButton props.`);
  }
  const {
    app,
    screen,
    uniqueId,
    upgradeProduct,
    upgradeKey
  } = upgradeData;

  //Temp check to track marketing-starter
  if (upgradeProduct === MARKETING_STARTER) {
    Raven.captureException(new Error('Checkout button with Marketing-starter upgradeProduct'), {
      extra: {
        uniqueId,
        app
      }
    });
  }

  // Per discussion with Liana: https://hubspot.slack.com/archives/CC04HSNNQ/p1682102540191569?thread_ts=1681323565.204229&cid=CC04HSNNQ
  const source = upgradeKey || getSource({
    app,
    screen,
    uniqueId
  }, CHECKOUT);
  const upgradeDataWithApiName = Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(canViewNewSeats, upgradeData.upgradeProduct, 'UICheckoutButton', upgradeData.apiName),
    source
  });
  const correctedProps = Object.assign({}, props, {
    upgradeData: upgradeDataWithApiName
  });
  return /*#__PURE__*/_jsx(MultipleOfferCheckoutButton, Object.assign({}, correctedProps));
};
export default UICheckoutButton;